import { useQuery } from "@tanstack/react-query";
import { loadSupabase } from "@/lib/supabaseLazy";
import { useAuth } from "@/contexts/AuthContext";

export const useUserRole = () => {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["user-role", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const supabase = await loadSupabase();
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user!.id);
      if (error) throw error;
      return data?.map((r: { role: string }) => r.role) ?? [];
    },
  });

  return {
    roles: data ?? [],
    isAdmin: (data ?? []).includes("admin"),
    isLoading,
  };
};
